import _typeof from "/home/eletter/.jenkins/workspace/eletter_release/h5/platform/node_modules/@babel/runtime/helpers/esm/typeof";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapMutations } from 'vuex';
import nextStep from '@/components/nextStep/nextStep.vue';
import { setStorage, getStorage } from "@/utils/localhost";
export default {
  components: {
    nextStep: nextStep
  },
  data: function data() {
    return {
      curChoseStep: -1,
      btn1text: '下一步',
      btn2text: '取消',
      btn2BgColor: '#fff',
      btn2textColor: 'black',
      list: [{
        name: '选择认证方式',
        id: 'choseCertRoute',
        router: '/internalSystem/certification/choseCertRoute',
        status: 'process',
        isShow: true,
        backData: 'certType'
      }, {
        name: '填写基本信息',
        id: 'basic',
        router: '/internalSystem/certification/basicInfo',
        status: 'process',
        isShow: true,
        backData: 'basicFlag',
        children: [{
          name: '基本信息',
          router: 'info'
        }, {
          name: '联系方式',
          router: 'contact'
        }, {
          name: '资质认证',
          router: 'qualifyCertificate'
        }, {
          name: '企业基本户信息',
          router: 'essentialInfo'
        }, {
          name: '其他资料',
          router: 'otherMaterial'
        }, {
          name: '提交认证',
          router: 'certificating'
        }]
      }, {
        name: '手机号认证',
        router: '/internalSystem/certification/phoneAuthentication',
        status: 'process',
        isShow: true,
        id: 'phone',
        backData: 'certPhoneFlag'
      }, {
        name: '银行基本账户认证',
        router: '/internalSystem/certification/accountId',
        status: 'process',
        isShow: true,
        id: 'account',
        backData: 'payFlag'
      }, {
        name: '确定签章授权协议',
        router: '/internalSystem/certification/anAgreement',
        status: 'process',
        isShow: true,
        id: 'anAgreement',
        backData: 'signFlag'
      }, {
        name: '企业认证完成',
        router: '/internalSystem/certification/complete',
        status: 'process',
        isShow: true,
        id: 'complete',
        backData: 'complete'
      }],
      active: -1,
      childrenStep: 0,
      timer: null //存量客户登陆提示补全企业信息的路由跳转定时器

    };
  },
  computed: {},
  watch: {
    enterpriseCert: {
      handler: function handler(a, b) {
        if (a != null) {
          this.initStep(a);
        }
      },
      deep: true
    },
    active: function active(a, b) {
      this.$router.push(this.list[a].router);

      if (a == 2) {
        this.btn1text = '已打款';
        this.btn2text = '查看认证信息';
      } else if (a == 3) {
        this.btn1text = '确认';
        this.btn2text = '取消';
      } else {
        this.btn1text = '下一步';
        this.btn2text = '取消';
      }
    }
  },
  created: function created() {
    if (this.userInfo.ifBasicAccoFlag == 0) {
      //0：关（取消基本户打款认证） 1：开启基本户打款认证
      for (var i = 0; i < this.list.length; i++) {
        if (this.list[i].id == 'account') {
          var tem = this.list[i];
          tem.isShow = false;
          this.$set(this.list, i, tem);
        }
      }
    }
  },
  mounted: function mounted() {
    this.getCertStatus();
  },
  methods: {
    // 直接跳转到基础信息步骤条(用于存量数据补全跳转)
    jumpBaseEdit: function jumpBaseEdit() {
      var _this = this;

      localStorage.removeItem("isBaseInfo"); //该跳转只执行一次，移除标识
      // 设置异步，否则无法控制监听active中的路由跳转和下面的执行先后

      this.timer = setTimeout(function () {
        _this.$router.push({
          path: '/internalSystem/certification/basicInfo',
          query: {
            edit: 1
          }
        });
      });
    },
    clickStep: function clickStep(item, index) {
      // console.log('this.enterpriseCert.certType',this.enterpriseCert.certType)
      if (item.id == 'basic') {
        // 基本户信息 需保证选择完认证方式
        // certType  0：法人路线  1:经办人 
        if (_typeof(this.enterpriseCert.certType) == undefined || this.enterpriseCert.certType == null || this.enterpriseCert.certType == -1) {
          this.$alert('请先选择认证方式', '提示', {
            confirmButtonText: '确定',
            type: 'warning',
            callback: function callback(action) {}
          });
          return;
        }
      } else if (item.id == 'phone') {
        // 手机号认证 需保证基本信息审核通过
        if (this.enterpriseCert.basicFlag != 2) {
          this.$alert('基本信息暂未通过，不能进行手机号认证', '提示', {
            confirmButtonText: '确定',
            type: 'warning',
            callback: function callback(action) {}
          });
          return;
        }
      } else if (item.id == 'account') {
        // 基本户认证 需保证基本信息审核通过
        if (this.enterpriseCert.basicFlag != 2) {
          this.$alert('基本信息暂未通过，不能进行基本户认证', '提示', {
            confirmButtonText: '确定',
            type: 'warning',
            callback: function callback(action) {}
          });
          return;
        }
      } else if (item.id == 'anAgreement') {
        // 点击协议 需保证基本信息审核通过，手机号认证通过
        // console.log('anAgreement', item)
        var bools = false;
        var tip = '';

        if (this.enterpriseCert.basicFlag != 2) {
          bools = true;
          tip = '基本信息暂未通过，不能进行签署协议';
        } else if (this.enterpriseCert.certPhoneFlag != 1) {
          bools = true;
          tip = '手机号认证暂未通过，不能进行签署协议';
        }

        if (bools) {
          this.$alert(tip, '提示', {
            confirmButtonText: '确定',
            type: 'warning',
            callback: function callback(action) {}
          });
          return;
        }
      } else if (item.id == 'complete') {
        // 点击认证完成  需保证基本信息审核通过，手机号认证通过,基本户认证完成，协议签署完成
        var _bools = false;
        var _tip = '';

        if (this.enterpriseCert.basicFlag != 2) {
          _bools = true;
          _tip = '基本信息暂未通过';
        } else if (this.enterpriseCert.certPhoneFlag != 1) {
          _bools = true;
          _tip = '手机号认证暂未通过';
        } else if (this.userInfo.ifBasicAccoFlag == '1' && this.enterpriseCert.payFlag != 1) {
          _bools = true;
          _tip = '基本户认证暂未通过';
        } else if (this.enterpriseCert.signFlag != 1) {
          _bools = true;
          _tip = '签章授权协议未签署';
        }

        if (_bools) {
          this.$alert(_tip, '提示', {
            confirmButtonText: '确定',
            type: 'warning',
            callback: function callback(action) {}
          });
          return;
        }
      } // console.log(item.router)


      this.$router.push(item.router);
      this.curChoseStep = index;
    },
    // 获取企业认证信息
    getCertStatus: function getCertStatus() {
      var _this2 = this;

      var data = {}; // 获取企业信息时，只能用主账户的userId, 主账号是自己的userId,子帐号是父级Id

      if (this.userInfo.sonFlag == 1) {
        data['usrId'] = this.userInfo.parentId;
      } else {
        data['usrId'] = this.userInfo.userId;
      }

      this.active = 0; //当前所处的步骤

      if (this.userInfo.creditCode) {
        // 用户中有信用代码说明已经认证
        this.requestAPI.getCertStatus(data).then(function (res) {
          if (res.data == null) {
            return;
          }

          _this2.initStep(res.data);

          if (res.data.userId == null) {
            res.data.userId = _this2.userInfo.userId;
          }

          res.data['certType'] = Number(res.data.certType);

          _this2.$store.commit('onChangeCert', res.data);

          var temData = _this2.userInfo;
          temData.basicFlag = res.data.basicFlag;
          temData.certPhoneFlag = res.data.certPhoneFlag;
          temData.payFlag = res.data.payFlag;
          temData.signFlag = res.data.signFlag;

          _this2.$store.commit('onchangeUserInfo', temData);

          getStorage('isBaseInfo') && _this2.jumpBaseEdit(); //当需要补全企业信息时执行跳转到基础信息模块
        });
      } else {
        // 没有认证的，先获取暂存的信息
        // 企业暂存，对于第一大步骤基本信息里的小步骤，点击下一步时，会现将当前页信息提交至后端，下次进入页面可继续填写，会暂存15天，15天后清楚暂存的信息
        // 暂存信息
        this.requestAPI.getTempData(data).then(function (res) {
          if (res.data == null) {
            return;
          } // 第一步骤状态   基本信息


          if (res.data.tempStatus) {
            res.data.notSignContract = res.data.preContract;
          }

          _this2.initStep(res.data);

          if (res.data.userId == null) {
            res.data.userId = _this2.userInfo.userId;
          }

          res.data['certType'] = Number(res.data.certType);

          _this2.$store.commit('onChangeCert', res.data);

          getStorage('isBaseInfo') && _this2.jumpBaseEdit(); //当需要补全企业信息时执行跳转到基础信息模块
        });
      }
    },
    // 根据当前暂存信息的数据，跳转至哪个小步骤，比如第二小步骤上次提交了，则下次进来会显示第三小步骤
    initStep: function initStep(data) {
      if (data.certType == -1 || data.certType == null) {
        this.active = 0;
      } else if (data.basicFlag != 2) {
        this.active = 1;
      } else if (data.certPhoneFlag != 1) {
        this.active = 2;
      } else if (this.userInfo.ifBasicAccoFlag == '1' && data.payFlag != 1) {
        this.active = 3;
      } else if (data.signFlag != 1) {
        this.active = 4;
      } else {
        this.active = 5;
      } // 更新上方步骤条的标志， process 当前所处的步骤  success成功   error 未完成


      for (var i = 0; i < this.list.length; i++) {
        var tem = this.list[i];

        if (tem.backData == 'basicFlag') {
          if (data.basicFlag == 1) {
            tem.status = 'process';
          } else if (data.basicFlag == 2) {
            tem.status = 'success';
          } else {
            tem.status = 'error';
          }
        } else if (tem.backData == 'certType') {
          if (data.certType == 1 || data.certType == 0) {
            tem.status = 'success';
          } else {
            tem.status = 'error';
          }
        } else if (tem.backData == 'complete') {
          if ((data.certType == 0 || data.certType == 1) && data.basicFlag == 2 && data.certPhoneFlag == 1 && data.payFlag == 1 && data.signFlag == 1) {
            tem.status = 'success';
          } else {
            tem.status = 'error';
          }
        } else {
          if (data[this.list[i].backData] == 1) {
            tem.status = 'success';
          } else {
            tem.status = 'error';
          }
        }

        this.$set(this.list, i, tem);
      }

      return;
    },
    // 外层的下一步
    nextStepFun: function nextStepFun() {
      if (this.active == 0) {} else {
        this.active += 1;
      }
    },
    cancel: function cancel() {
      if (this.active > 0) {
        this.active -= 1;
      }

      this.$router.go(-1);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.timer = null;
  }
};